import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/frontend/node_modules/next/dist/client/app-dir/link.js");
